import { Component,Inject, OnInit } from '@angular/core';
import {ServiceordreDto} from "../../api/models/OK/EGIS/Service/Ekstern/Models/DTO/serviceordre-dto";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: ServiceordreDto) { }

  ngOnInit(): void {
  }

}
